import Button from '@ui/Button';
import AuthProvider from 'context/AuthContext';
import { GoogleBrandIcon, AppleBrandIcon } from './icons';

const SocialLoginButtons = ({
  handleSocialClick,
  startTabIndex,
}: {
  handleSocialClick: (s: AuthProvider) => Promise<void>;
  startTabIndex?: number;
}) => (
  <div className="flex gap-[2rem]">
    <Button
      text={''}
      leadingIcon={<GoogleBrandIcon />}
      type="sso"
      onClick={() => handleSocialClick('google')}
      width="fluid"
      tabIndex={startTabIndex}
    />
    <Button
      text={''}
      leadingIcon={<AppleBrandIcon />}
      type="sso"
      onClick={() => handleSocialClick('apple')}
      width="fluid"
      tabIndex={startTabIndex ? startTabIndex + 1 : undefined}
    />
  </div>
);

export default SocialLoginButtons;
